import request from '../../plugins/request'

//获取评论（消息）
export function getAuthorCommentServiceList(data) {
	return request({
		url: '/api/AuthorComment/GetAuthorCommentServiceList',
		method: 'post',
		data
	})
}
//删除消息
export function deleteAuthorCommentService(data) {
	return request({
		url: '/api/AuthorComment/DeleteAuthorCommentService',
		method: 'post',
		data
	})
}
//清空消息
export function clearAuthorCommentService(data) {
	return request({
		url: '/api/AuthorComment/ClearAuthorCommentService',
		method: 'post',
		data
	})
}